import * as actionType from './types'
import { AnyAction } from 'redux'

export const setSelectedReferencesAll = (references:any): AnyAction => ({ type: actionType.SET_SELECTED_REFERENCES_ALL, payload: references })
export const setSelectedReferencesSubject = (id:any): AnyAction => ({ type: actionType.SET_SELECTED_REFERENCES_SUBJECT, payload: id })
export const setSelectedRefSource = (inner_id:any): AnyAction => ({ type: actionType.SET_SELECTED_REF_SOURCE, payload: inner_id })
export const setSelectedReferencesEvent = (id:any): AnyAction => ({ type: actionType.SET_SELECTED_REFERENCES_EVENT, payload: id })
export const setSelectedReferencesSphere = (id:any): AnyAction => ({ type: actionType.SET_SELECTED_REFERENCES_SPHERE, payload: id })
export const removeSelectedReferences = (): AnyAction => ({ type: actionType.REMOVE_SELECTED_REFERENCES })
